import React from 'react';

/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */

export class NoSwapButton extends React.Component{
    render(){
        return(
            <button className="App-button" style={this.props.style} onClick={this.props.onClick} >
              Nicht Tauschen
            </button> 
        )};
}